function progressBarClassChange() {
    const finalStep = document.querySelector(".sk-app[data-process-step-id*=':Final']");
    if ( !finalStep ) return;

    const progressBarItem = document.querySelector(".sk-progress-bar-content").lastChild;
    progressBarItem.classList.remove("sk-step--active");
    progressBarItem.classList.add("sk-step--completed");
};

export { progressBarClassChange };